import { getAccessTokenFromCookie, getIdTokenFromCookie } from "../util/authentication";
import { getPermBidDealineEpochTimestamp } from "../util/bid/bidCommon";
import { BID_DATE_TYPE } from "../util/bid/bidConstants";
import {
  BID_SERVICE_API_ADD_BID_EVENT,
  BID_SERVICE_API_DELETE_PERM_BID_EVENT,
  BID_SERVICE_API_ADD_EMP_BID_CHOICE_EVENT,
  BID_SERVICE_API_GET_LATEST_BID_EVENTS_BY_STATION_AND_DATE,
  BID_SERVICE_API_GET_LATEST_BID_EVENT_BY_REFERENCE_NUMBER,
  BID_SERVICE_API_GET_LATEST_BID_GROUP_EMP_EVENTS_BY_REFERENCE_NUMBER,
  BID_SERVICE_API_GET_LATEST_BID_ALLOTMENT_EVENTS_BY_REFERENCE_NUMBER,
  BID_SERVICE_API_GET_LATEST_BID_LINE_EVENTS_BY_REFERENCE_NUMBER,
  BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENTS_BY_EID_AND_DATE,
  BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENT_BY_REFERENCE_NUMBER_AND_EID,
  BID_SERVICE_API_GET_LATEST_PERMANENT_BID_BY_EID,
  BID_SERVICE_API_GET_PERMANENT_BID_PDF,
  BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENTS_BY_REFERENCE_NUMBER,
  BID_SERVICE_API_GET_BID_EVENTS_BY_REFERENCE_NUMBER,
  BID_SERVICE_API_GET_LATEST_AWARD_LOGS_BY_REFERENCE_NUMBER,
  BID_SERVICE_API_CALCULATE_FREEDAY_ALLOTMENTS,
  BID_SERVICE_API_GET_LATEST_PERMANENT_BID_BY_EID_AND_DATE,
  BID_SERVICE_API_CALCULATE_IAM_FTO_ALLOTMENTS,
  BID_SERVICE_API_GET_BID_AUDIT_HISTORY_BY_REFERENCE_NUMBER,
} from "../util/constants";
import { getISODateTimeString } from "../util/dateTimeFormatter";

export const fetchLatestPermanentBid = async (eid) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_GET_LATEST_PERMANENT_BID_BY_EID + "/" + eid;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
      "id-token": getIdTokenFromCookie(),
    },
  });

  if (!response.ok) {
    if (response.status === 404) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }

  return response;
};

export const fetchLatestPermanentBidEventsByEidAndDate = async (eid, bidData) => {
  const date = getPermBidDealineEpochTimestamp(bidData);
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_PERMANENT_BID_BY_EID_AND_DATE +
    "/" +
    eid +
    "/" +
    date;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    console.error(response);
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchPermanentBidPDF = async (eid) => {
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_GET_PERMANENT_BID_PDF + "/" + eid;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const addBidEvent = async (bidEventPayload) => {
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_ADD_BID_EVENT;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(bidEventPayload),
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deletePermanentBidEvent = async (bidEventPayload) => {
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_DELETE_PERM_BID_EVENT;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(bidEventPayload),
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const addBidChoiceEvent = async (bidEventPayload) => {
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_ADD_EMP_BID_CHOICE_EVENT;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: JSON.stringify(bidEventPayload),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const fetchLatestBidEventsByStationAndDate = async (eid, station, dateType, startDate, endDate) => {
  switch (dateType) {
    case BID_DATE_TYPE.BID_EFFECTIVE_DATE:
    case BID_DATE_TYPE.BID_WINDOW_DATE:
      startDate = getISODateTimeString(startDate);
      endDate = getISODateTimeString(endDate);
      break;
    case BID_DATE_TYPE.LAST_UPDATED_DATE:
      startDate = startDate.toMillis();
      endDate = endDate.toMillis();
      break;
    default:
      console.error("Unrecognized dateType: ", dateType);
  }

  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_EVENTS_BY_STATION_AND_DATE +
    "/" +
    station +
    "/" +
    dateType +
    "/" +
    startDate +
    "/" +
    endDate;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestBidEventByReferenceNumber = async (eid, referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_EVENT_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestBidGroupEmpEventsByReferenceNumber = async (eid, referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_GROUP_EMP_EVENTS_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestBidAllotmentEventsByReferenceNumber = async (eid, referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_ALLOTMENT_EVENTS_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestBidLineEventsByReferenceNumber = async (eid, referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_LINE_EVENTS_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestEmployeeBidChoiceEventsByEidAndDate = async (eid, dateType, startDate, endDate) => {
  switch (dateType) {
    case BID_DATE_TYPE.BID_EFFECTIVE_DATE:
    case BID_DATE_TYPE.BID_WINDOW_DATE:
      startDate = getISODateTimeString(startDate);
      endDate = getISODateTimeString(endDate);
      break;
    case BID_DATE_TYPE.LAST_UPDATED_DATE:
      startDate = startDate.toMillis();
      endDate = endDate.toMillis();
      break;
    default:
      console.error("Unrecognized dateType: ", dateType);
  }
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENTS_BY_EID_AND_DATE +
    "/" +
    eid +
    "/" +
    dateType +
    "/" +
    startDate +
    "/" +
    endDate;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    console.error(response);
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestBidChoiceEventByReferenceNumberAndEid = async (eid, referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENT_BY_REFERENCE_NUMBER_AND_EID +
    "/" +
    referenceNumber +
    "/" +
    eid;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
      "id-token": getIdTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestBidChoiceEventsByReferenceNumber = async (referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_BID_CHOICE_EVENTS_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchAllBidEventsByReferenceNumber = async (referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_GET_BID_EVENTS_BY_REFERENCE_NUMBER + "/" + referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchBidAuditHistoryByReferenceNumber = async (referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_GET_BID_AUDIT_HISTORY_BY_REFERENCE_NUMBER + "/" + referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestBidAwardLogsByReferenceNumber = async (referenceNumber) => {
  const apiEndpoint =
    process.env.REACT_APP_BID_SERVICE_API +
    BID_SERVICE_API_GET_LATEST_AWARD_LOGS_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const calculateFreedayAllotments = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_CALCULATE_FREEDAY_ALLOTMENTS;
  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const calculateIAMFTOAllotments = async (payload) => {
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_CALCULATE_IAM_FTO_ALLOTMENTS;
  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const calculateTWUDATFTOAllotments = async (payload) => {
  // TODO: Change the API point to DAT/FTO during STARTEC-2531
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_CALCULATE_IAM_FTO_ALLOTMENTS;
  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const calculateIAMDATAllotments = async (payload) => {
  // TODO: Change the API point to IAM DAT during STARTEC-2579
  const apiEndpoint = process.env.REACT_APP_BID_SERVICE_API + BID_SERVICE_API_CALCULATE_IAM_FTO_ALLOTMENTS;
  const response = await fetch(apiEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};
